module.exports = __webpack_public_path__ + "static/vf-button-dress.ba0a6ff2.svg";